import { FlowEvent, WBSState } from './types'

export default function wbsDataReducer(
    state: WBSState = {
        layers: new Map<number, string>(),
        bitdepth: undefined,
        done: false,
        depthMD: 'm',
        trajectory: [],
        uom: {},
        span: { begin: 0, end: 0 }
    },
    event: FlowEvent | undefined
): WBSState {
    if (!event) {
        return state
    }

    switch (event.type) {
        case 'start':
            // eslint-disable-next-line no-case-declarations
            const layer = event.events.info.layer
            if (layer === 'trajectory') {
                state.depthMD = event.events.info.uom.md
            }
            state.layers.set(event.layer, layer)
            state[layer] = []
            if (event.events.info.uom) {
                state.uom[layer] = event.events.info.uom
            }

            return state
        case 'event':
            // eslint-disable-next-line eqeqeq
            if (event.events.length == 0) {
                return state
            }
            // eslint-disable-next-line no-case-declarations
            const layerType = state.layers.get(event.layer)
            if (!state[layerType]) {
                state[layerType] = []
            }

            switch (layerType) {
                case 'bitdepth':
                    if (Array.isArray(event.events) && event.events.length > 0) {
                        state.bitdepth = parseFloat(event.events[0].bitdepth)
                    }
                    break

                case 'sections':
                    if (Array.isArray(event.events) && event.events.length > 0) {
                        const info = event.events[0]
                        state[layerType] = 'sections' in info ? info.sections : []
                    }
                    break

                case 'trajectory':
                    state[layerType] = event.events
                    break

                default:
                    state[layerType] = state[layerType].concat(event.events)
            }

            return state
        default:
            return state
    }
}
